import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { AdminRoute } from './components/common/AdminRoute';

// Client pages
import DepotPage from './pages/client/DepotPage';
import MessagePage from './pages/client/MessagePage';

// Auth pages
import LoginPage from './pages/auth/LoginPage';
import CallbackPage from './pages/auth/CallbackPage';

// Admin pages
import AdminLayout from './components/common/AdminLayout';
import DashboardPage from './pages/admin/DashboardPage';
import DepositsPage from './pages/admin/DepositsPage';
import MessagesPage from './pages/admin/MessagesPage';
import AuditPage from './pages/admin/AuditPage';
import SettingsPage from './pages/admin/SettingsPage';

// Common pages
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Routes>
        {/* Public client routes */}
        <Route path="/depot" element={<DepotPage />} />
        <Route path="/message/:token" element={<MessagePage />} />

        {/* Auth routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<CallbackPage />} />

        {/* Protected admin routes - PowerAdmin */}
        <Route
          path="/poweradmin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="deposits" element={<DepositsPage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="audit" element={<AdminRoute><AuditPage /></AdminRoute>} />
          <Route path="settings" element={<AdminRoute><SettingsPage /></AdminRoute>} />
        </Route>

        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/depot" replace />} />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}
